module.exports = __webpack_public_path__ + "img/3266532.jpg";